import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 col-xxl-6 col-sm-6 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { key: 6 }
const _hoisted_13 = { key: 7 }
const _hoisted_14 = { key: 8 }
const _hoisted_15 = {
  key: 0,
  class: "badge text-bg-danger fw-medium"
}
const _hoisted_16 = {
  key: 1,
  class: "badge text-bg-success fw-medium"
}
const _hoisted_17 = { key: 9 }
const _hoisted_18 = {
  key: 0,
  class: "badge text-bg-danger fw-medium"
}
const _hoisted_19 = {
  key: 1,
  class: "badge text-bg-success fw-medium"
}
const _hoisted_20 = { class: "col-md-6 col-xxl-6 col-sm-6 mb-10" }
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_22 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_23 = { class: "table" }
const _hoisted_24 = {
  key: 0,
  style: {"color":"red !important"}
}
const _hoisted_25 = {
  key: 1,
  style: {"color":"black !important"}
}
const _hoisted_26 = { class: "card-footer bg-white" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = {
  class: "justify-content-between",
  style: {"display":"flex"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Informations de l'abonnement", -1)),
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              (_ctx.abonnement)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                    _cache[1] || (_cache[1] = _createElementVNode("td", null, "ABONNEMENT", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.refAbo), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "DEMANDEUR", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.nomComplet), 1)
              ]),
              (_ctx.abonnement?.adresseVirtuelle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("td", null, "Adresse virtuelle", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.adresseVirtuelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.boite?.adressePostale?.adresse_postale)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "Adresse postale", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.adressePostale.adresse_postale), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.boite)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _cache[5] || (_cache[5] = _createElementVNode("td", null, "Modele de boite", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.modele?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.boite)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, "Boite postale", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.refBoite), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.loyer)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("td", null, "Tarif", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.loyer + " F CFA"), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.caution)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, "Caution", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.caution), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.createdAt)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _cache[9] || (_cache[9] = _createElementVNode("td", null, "Date d'abonnement", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date(_ctx.abonnement?.createdAt)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _cache[10] || (_cache[10] = _createElementVNode("td", null, "Etat abonnement", -1)),
                    _createElementVNode("td", null, [
                      (_ctx.abonnement.estResilier)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Inactif "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_16, "Actif"))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _cache[11] || (_cache[11] = _createElementVNode("td", null, "Arrierés", -1)),
                    _createElementVNode("td", null, [
                      (_ctx.totaleArr.arrires > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.totaleArr.arrires? (_ctx.totaleArr.arrires+ " F CFA") : 0 + " F CFA"), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.totaleArr.arrires? _ctx.totaleArr.arrires : 0 + " F CFA"), 1))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Redevances en attente", -1)),
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redevances, (red, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(red?.annee), 1),
                  _createElementVNode("td", null, _toDisplayString(red?.montant +" Fcfa"), 1),
                  _createElementVNode("td", null, _toDisplayString(red.arrieres +"Fcfa"), 1)
                ]))
              }), 128))
            ])
          ]),
          (_ctx.etatBouton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.messageClient), 1))
            : _createCommentVNode("", true),
          (!_ctx.etatBouton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.messageClient), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_ctx.demande?.status !== 'Validée' )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass([{disabled:_ctx.etatBouton === true }, "btn btn-success"]),
                    href: "javascript:void(0);",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accept(_ctx.demande)))
                  }, " Acceptée ", 2))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}